import React from 'react';

import { HawkWidgetContext } from '../HawkWidget/HawkWidgetContext';

import styles from './styles/title.css';

interface TitleProps {
  title: string;
  className?: string | null;
}

const Title: React.FC<TitleProps> = React.memo(({ title, className }: TitleProps) => (
  <HawkWidgetContext.Consumer>
    {(value): JSX.Element | null => {
      const { showWidgetTitle } = value;

      if (showWidgetTitle && title) {
        const containerClassName = className && styles[className] ? className : 'container';
        const Tag = className && ['tile', 'mostPopularOffers '].includes(className) ? 'h2' : 'div';

        return <Tag className={styles[containerClassName]}>{title}</Tag>;
      }
      return null;
    }}
  </HawkWidgetContext.Consumer>
));

export default Title;
